import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as am5 from '@amcharts/amcharts5';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

am5.addLicense(environment.am5chartLicense);

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
